const DEVICE_KEY = "pai_device";
const LEGACY_DEVICE_KEY = "pai_device_legacy";

function randomDeviceId() {
  return (crypto.randomUUID && crypto.randomUUID()) || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function nativeIdentityPlugin() {
  return window.Capacitor && window.Capacitor.Plugins ? window.Capacitor.Plugins.NativeIdentity : null;
}

async function getNativeDeviceId() {
  const plugin = nativeIdentityPlugin();
  if (!plugin || typeof plugin.getId !== "function") return null;
  try {
    const result = await plugin.getId();
    return result && (result.device_id || result.identifier || result.id) ? String(result.device_id || result.identifier || result.id) : null;
  } catch (error) {
    console.warn("Nativer Geratecode konnte nicht gelesen werden:", error);
    return null;
  }
}

export async function resolveDeviceIdentity() {
  const storedDeviceId = localStorage.getItem(DEVICE_KEY);
  const storedLegacyId = localStorage.getItem(LEGACY_DEVICE_KEY);
  const nativePlatform = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  const nativeDeviceId = nativePlatform ? await getNativeDeviceId() : null;

  if (nativeDeviceId) {
    const legacyDeviceId =
      (storedDeviceId && storedDeviceId !== nativeDeviceId && storedDeviceId) ||
      (storedLegacyId && storedLegacyId !== nativeDeviceId && storedLegacyId) ||
      null;
    localStorage.setItem(DEVICE_KEY, nativeDeviceId);
    if (legacyDeviceId) {
      localStorage.setItem(LEGACY_DEVICE_KEY, legacyDeviceId);
    } else {
      localStorage.removeItem(LEGACY_DEVICE_KEY);
    }
    return { deviceId: nativeDeviceId, legacyDeviceId };
  }

  if (storedDeviceId) {
    return {
      deviceId: storedDeviceId,
      legacyDeviceId: storedLegacyId && storedLegacyId !== storedDeviceId ? storedLegacyId : null,
    };
  }

  const deviceId = randomDeviceId();
  localStorage.setItem(DEVICE_KEY, deviceId);
  return { deviceId, legacyDeviceId: null };
}

export function clearLegacyDeviceIdentity() {
  localStorage.removeItem(LEGACY_DEVICE_KEY);
}
